import React from 'react';
import { Box, Typography } from '@mui/material';
import Card from 'dashboard/components/card/Card.js';
import InformationDetails from 'dashboard/pages/brand/settings/components/InformationDetails';

export default function Information(props) {
  return (
    <Card sx={{ mb: '20px' }} {...props}>
      <Box mb='30px' ml='10px'>
        <Typography variant='h6' fontWeight='bold'>Brand Settings</Typography>
        <Typography variant='body2' color='text.secondary'>
          Here you can change brand information
        </Typography>
      </Box>
      <InformationDetails {...props} embedded />
    </Card>
  );
}
